import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import FabPlateau from "src/components/UiComponents/Buttons/FabPlateau";
import IconButton from "src/components/IconButton";
import {
  faAdd,
  faPencil as PencilIcon,
  faTrash as DeleteIcon,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useModal from "src/components/Modal/hooks/useModal";
import ConfirmDeleteDialog from "src/components/Modal/ConfirmDelete";
import {
  showSuccessToast,
  showValidationErrorToast,
} from "src/components/Toasts";
import axios from "src/config/axios";
import { useTranslation } from "react-i18next";
import EditEmailTemplateDialog from "./EditEmailTemplateDialog";

const triggerLabels = {
  after_checkout: "Nach Checkout",
};

const emptyEmailTemplate = {
  name: "",
  trigger: "after_checkout",
  active: false,
  subject: "",
  subject_it: "",
  subject_en: "",
  body: "",
  body_it: "",
  body_en: "",
};

const EmailTemplatesSettingsPage = () => {
  function handleEdit(emailTemplate) {
    setSelectedEmailTemplate(emailTemplate);
    toggleEdit();
  }

  function handleArchive(emailTemplate) {
    setSelectedEmailTemplate(emailTemplate);
    toggleArchive();
  }

  function handleCreate() {
    setSelectedEmailTemplate(emptyEmailTemplate);
    toggleEdit();
  }
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [selectedEmailTemplate, setSelectedEmailTemplate] =
    useState(emptyEmailTemplate);
  const { isShow: showEdit, toggle: toggleEdit } = useModal();
  const { isShow: showArchive, toggle: toggleArchive } = useModal();
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    fetchEmailTemplates();
  }, []);

  const fetchEmailTemplates = () => {
    axios
      .get("/api/v1/email_templates.json")
      .then(function (response) {
        setEmailTemplates(response.data.entries);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const archive = (emailTemplate) => {
    axios
      .delete(`/api/v1/email_templates/${emailTemplate.id}.json`)
      .then(function () {
        showSuccessToast();
        fetchEmailTemplates();
      })
      .catch(function (error) {
        showValidationErrorToast(error);
      });
  };

  const sendTestEmail = (emailTemplate) => {
    axios
      .post(`/api/v1/email_templates/${emailTemplate.id}/send_test_email.json`)
      .then(function () {
        showSuccessToast();
      })
      .catch(function (error) {
        showValidationErrorToast(error);
      });
  };

  const handleEdited = () => {
    showSuccessToast();
    fetchEmailTemplates();
  };

  const handleDelete = () => {
    archive(selectedEmailTemplate);
    toggleArchive();
  };

  return (
    <>
      <Card title={`E-Mail-Vorlagen (${emailTemplates.length ?? 0})`}>
        <div className="table-responsive">
          <div className="ui-table-container">
            <table
              className="table table-bordered"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Trigger</th>
                  <th>Aktiv</th>
                  <th>Optionen</th>
                </tr>
              </thead>
              <tbody>
                {emailTemplates.map((emailTemplate) => (
                  <tr key={emailTemplate.id}>
                    <td>{emailTemplate.name}</td>
                    <td>
                      {triggerLabels[emailTemplate.trigger] ??
                        emailTemplate.trigger}
                    </td>
                    <td>{emailTemplate.active ? "Ja" : "Nein"}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="mr-3"
                        onClick={() => {
                          sendTestEmail(emailTemplate);
                        }}
                      >
                        Test E-Mail
                      </Button>
                      <IconButton
                        className="mr-1 bg-transparent border-0 mr-3"
                        textColor="var(--primary)"
                        icon={PencilIcon}
                        onClick={() => handleEdit(emailTemplate)}
                      />
                      <IconButton
                        className="mr-2 mr-3 bg-transparent border-0"
                        textColor="var(--danger)"
                        icon={DeleteIcon}
                        onClick={() => handleArchive(emailTemplate)}
                      />
                    </td>
                  </tr>
                ))}
                {emailTemplates.length === 0 && (
                  <tr>
                    <td colSpan={4}>
                      {t("common:components.table.noEntries")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Row className="justify-content-end mr-2 mt-5">
          <FabPlateau>
            <Button
              className="float-right p-2 pl-3 pr-3"
              variant="primary"
              onClick={handleCreate}
            >
              <FontAwesomeIcon icon={faAdd} />{" "}
              {t("common:components.button.new")}
            </Button>
          </FabPlateau>
        </Row>
      </Card>
      {showEdit && (
        <EditEmailTemplateDialog
          toggle={toggleEdit}
          emailTemplate={selectedEmailTemplate}
          handleSuccess={handleEdited}
        />
      )}
      <ConfirmDeleteDialog
        show={showArchive}
        handleClose={toggleArchive}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default EmailTemplatesSettingsPage;
